// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7f1c0e33","703":"8f5db2e6","787":"08e69e84"}[chunkId] + ".chunk.js";
};